import $ from 'jquery';
import { deleteTagBackground } from '../backgroundTags/deleteTagBackground';

export const onclickDeleteBackgroundTag = (event) => {
  const sidebarCurrentBackgroundTagItemId = $(event.currentTarget).data(
    'delete-background-id'
  );

  const sidebarCurrentTagItemId = $(event.currentTarget).data(
    'delete-background-tag-id'
  );
  const sidebarCurrentStatusTag = $(event.currentTarget).data(
    'delete-background-tag-status'
  );
  deleteTagBackground(
    sidebarCurrentBackgroundTagItemId,
    sidebarCurrentTagItemId,
    sidebarCurrentStatusTag
  );
};
